import { FC } from 'react';
import { SPACING_WEB } from '@connect-x-app/shared-ui';
import { clsx } from 'clsx';

import { SWITCH_MODE_COMBINATIONS, SWITCH_SIZES, SwitchProps } from './Switch.shared';

import './Switch.scss';

export const Switch: FC<SwitchProps> = ({
  className,
  icon,
  isDisabled,
  onChange,
  size = 'm',
  testId,
  type = 'primary',
  value,
}) => {
  const sizeStyles = SWITCH_SIZES[size];
  const activeState = value ? 'on' : 'off';
  const activeType = isDisabled ? 'disabled' : type;
  const colorStyles = SWITCH_MODE_COMBINATIONS[activeType][activeState];

  const switchStyle = {
    alignItems: 'center',
    backgroundColor: colorStyles.track.background,
    borderColor: colorStyles.track.border,
    borderRadius: '12rem',
    borderStyle: 'solid',
    borderWidth: '1px',
    boxSizing: 'border-box' as const,
    cursor: isDisabled ? 'default' : 'pointer',
    display: 'flex',
    height: `${sizeStyles.height}rem`,
    padding: `${SPACING_WEB.xs}rem`,
    width: `${sizeStyles.width}rem`,
  };

  const thumbStyle = {
    backgroundColor: colorStyles.thumb.background,
    color: colorStyles.track.background,
  };

  return (
    <label className={clsx('switch', className)} data-test={testId} style={switchStyle}>
      <input checked={value} disabled={isDisabled} onChange={event => onChange(event.target.checked)} type="checkbox" />
      <span className="slider round" style={thumbStyle}>
        {icon}
      </span>
    </label>
  );
};
